"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeToggler = void 0;
const core_1 = require("@bem-react/core");
const __1 = require("..");
__exportStar(require("../ThemeToggler.types"), exports);
exports.ThemeToggler = (0, core_1.compose)()(__1.ThemeToggler);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYnVuZGxlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vc3JjL1RoZW1lVG9nZ2xlci9kZXNrdG9wL2J1bmRsZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDBDQUEwQztBQUUxQywwQkFBc0Q7QUFDdEQsd0RBQXNDO0FBRXpCLFFBQUEsWUFBWSxHQUFHLElBQUEsY0FBTyxHQUFFLENBQUMsZ0JBQWdCLENBQUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGNvbXBvc2UgfSBmcm9tICdAYmVtLXJlYWN0L2NvcmUnO1xuXG5pbXBvcnQgeyBUaGVtZVRvZ2dsZXIgYXMgVGhlbWVUb2dnbGVyQmFzZSB9IGZyb20gJy4uJztcbmV4cG9ydCAqIGZyb20gJy4uL1RoZW1lVG9nZ2xlci50eXBlcyc7XG5cbmV4cG9ydCBjb25zdCBUaGVtZVRvZ2dsZXIgPSBjb21wb3NlKCkoVGhlbWVUb2dnbGVyQmFzZSk7XG5cbmV4cG9ydCB0eXBlIHsgVGhlbWVOYW1lIH0gZnJvbSAnLi4vVGhlbWVUb2dnbGVyLnR5cGVzJztcbiJdfQ==